(() => {
  'use strict';
  const PROFILE_KEY='alora_interest_profile_v2';
  const SESSION_KEY='alora_interest_session_v2';
  const MAX_AGE=45*24*60*60*1000;

  const empty=()=>({updatedAt:Date.now(),handles:{},vendors:{},types:{},tags:{},categories:{},cart:{}});
  const safeParse=(v,f)=>{try{return JSON.parse(v)||f}catch{return f}};
  const allowed=()=>{try{
    const cp=window.Shopify&&window.Shopify.customerPrivacy;
    if(!cp) return false;
    if(typeof cp.preferencesProcessingAllowed==='function') return !!cp.preferencesProcessingAllowed();
    if(typeof cp.analyticsProcessingAllowed==='function') return !!cp.analyticsProcessingAllowed();
  }catch{} return false};
  const store=()=>allowed()?localStorage:sessionStorage;
  const read=()=>{
    const s=store();
    let p=safeParse(s.getItem(allowed()?PROFILE_KEY:SESSION_KEY),empty());
    if(!p.updatedAt||Date.now()-p.updatedAt>MAX_AGE) p=empty();
    return p;
  };
  const write=p=>{try{p.updatedAt=Date.now();store().setItem(allowed()?PROFILE_KEY:SESSION_KEY,JSON.stringify(p))}catch{}};
  const bump=(obj,key,points)=>{if(!key)return;key=String(key).trim().toLowerCase();if(!key)return;obj[key]=Math.min(100,(Number(obj[key])||0)+points)};
  const words=v=>String(v||'').split('|').map(x=>x.trim()).filter(Boolean).slice(0,16);
  const categoryFrom=text=>{
    text=String(text||'').toLowerCase();
    const groups=[
      ['skincare',['serum','sérum','cleanser','limpiador','toner','tónico','moistur','hidrat','sunscreen','protector solar','mask','mascarilla','retinol','cica','snail']],
      ['perfumes',['perfume','parfum','eau de','cologne','colonia','fragrance','body mist','splash']],
      ['cabello',['hair','cabello','shampoo','conditioner','acondicionador','scalp','styling','peinado']],
      ['maquillaje',['makeup','maquillaje','lip','labial','blush','rubor','mascara','foundation','base','concealer','corrector','eyeshadow','sombra']],
      ['lentes',['lente','gafa','sunglass','anteojo']],
      ['vitaminas',['vitamin','suplement','supplement','collagen','colágeno']],
      ['sets',['kit','set','gift','regalo']]
    ];
    for(const [g,ks] of groups) if(ks.some(k=>text.includes(k))) return g;
    return '';
  };
  const record=(meta,points)=>{
    if(!meta) return;
    const p=read();
    bump(p.handles,meta.handle,points);
    bump(p.vendors,meta.vendor,points*.45);
    bump(p.types,meta.type,points*.7);
    words(meta.tags).forEach(t=>bump(p.tags,t,points*.15));
    bump(p.categories,categoryFrom([meta.title,meta.type,meta.tags].join(' ')),points*.8);
    write(p);
  };

  window.AloraPersonalization={read,allowed,record,categoryFrom};

  document.addEventListener('DOMContentLoaded',()=>{
    const ctx=document.getElementById('AloraProductContext');
    if(ctx){
      try{
        const meta=JSON.parse(ctx.textContent||'{}');
        setTimeout(()=>record(meta,2),6500);
        document.addEventListener('submit',e=>{
          const f=e.target.closest&&e.target.closest('form[action*="/cart/add"]');
          if(f) record(meta,10);
        },true);
      }catch{}
    }
  },{once:true});

  document.addEventListener('click',e=>{
    const card=e.target.closest&&e.target.closest('[data-alora-product-handle]');
    if(!card) return;
    const a=e.target.closest('a[href*="/products/"]');
    if(!a) return;
    record({
      handle:card.dataset.aloraProductHandle,
      vendor:card.dataset.aloraProductVendor,
      type:card.dataset.aloraProductType,
      tags:card.dataset.aloraProductTags,
      title:card.dataset.aloraProductTitle
    },4);
  },true);
})();
